import React from 'react';
import { buildCountryOptions } from '../../../utils/locationOptions';
import BaseSelect from './BaseSelect';

// 국가 목록을 우선순위 국가 먼저 노출하도록 구성한 셀렉터
export default function CountrySelect({
  value,
  onChange,
  className = '',
  priority = ['KR'],
  defaultOptionLabel = '국가',
  disabled = false,
  ...props
}) {
  const allOptions = buildCountryOptions('short');
  const prioritized = [
    ...allOptions.filter((o) => priority.includes(o.code)),
    ...allOptions.filter((o) => !priority.includes(o.code)),
  ];
  const options = prioritized.map((o) => ({ label: o.label, value: o.value, key: o.code }));

  return (
    <BaseSelect
      options={options}
      value={value}
      onChange={onChange}
      placeholder={defaultOptionLabel}
      className={className}
      disabled={disabled}
      ariaLabel="국가 선택"
      variant="country"
      {...props}
    />
  );
}
